import { css } from '@emotion/react';

import { Button } from '@zapier/design-system';

type Props = {
  children: React.ReactNode;
  onPress: () => void;
};

// These controls are actions, not navigation, so they have to be real
// `button`s — Zinnia's `Link` is only for links that go to a URL. Every Button
// variant draws a box though, and these sit mid-sentence, so strip the box back
// down to the inline underlined text they replace. The height is left alone:
// `compact` is already 24px, which matches the Body1 line box.
const inlineActionStyle = css`
  padding: 0;
  border: 0;
  font: inherit;
  text-decoration: underline;

  /* the ghost variant paints a tinted pill on hover, which reads wrong wrapped
     around inline text — the real links beside it only change colour */
  &:hover {
    background: none;
  }
`;

/**
 * An action rendered inline inside a sentence, styled to match the real links
 * it sits beside. Shared so the two auth pages that need it cannot drift apart.
 */
export function InlineActionButton({ children, onPress }: Props) {
  return (
    <Button
      css={inlineActionStyle}
      variant="ghost"
      size="compact"
      onPress={onPress}
    >
      {children}
    </Button>
  );
}
